// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var Skills$ReasonProfile = require("./skills/Skills.bs.js");
var ProfileInfo$ReasonProfile = require("./profile-info/ProfileInfo.bs.js");

require('./Profile.css')
;

var component = ReasonReact.statelessComponent("Profile");

function make(_children) {
  return {
          debugName: component.debugName,
          reactClassInternal: component.reactClassInternal,
          handedOffState: component.handedOffState,
          willReceiveProps: component.willReceiveProps,
          didMount: component.didMount,
          didUpdate: component.didUpdate,
          willUnmount: component.willUnmount,
          willUpdate: component.willUpdate,
          shouldUpdate: component.shouldUpdate,
          render: (function (_self) {
              return React.createElement("div", {
                          className: "Profile"
                        }, ReasonReact.element(undefined, undefined, ProfileInfo$ReasonProfile.make(/* array */[])), ReasonReact.element(undefined, undefined, Skills$ReasonProfile.make(/* array */[])));
            }),
          initialState: component.initialState,
          retainedProps: component.retainedProps,
          reducer: component.reducer,
          jsElementWrapped: component.jsElementWrapped
        };
}

exports.component = component;
exports.make = make;
/*  Not a pure module */
